import React from "react";
import Home from "../pages/Home";

import Logout from "../pages/Authentication/Logout";
import SignIn from "../pages/Authentication/SignIn";
import SignUp from "../pages/Authentication/SignUp";
import ConfirmAccount from "../pages/Authentication/ConfirmAccount";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import ResetPassword from "../pages/Authentication/ResetPassword";

// Dashboard
import Profile from "../pages/Profile/index";
import CurriculumV2 from "../pages/CurriculumV2/index";
import Candidatos from "../pages/Candidatos/index";
import CandidatoDetalhe from "../pages/Candidatos/CandidatoDetalhe";
import { CandidatosProvider } from "../pages/Candidatos/CandidatosContext";
import UsersList from "../pages/Admin/UsersList";
import Dashboard from "../pages/Admin/Dashboard";

// Route Guards
import ProfileRequiredRoute from "../components/Common/ProfileRequiredRoute";


const authProtectedRoutes = [
  { path: "/profile", component: <Profile /> },
  { path: "/curriculum", component: <ProfileRequiredRoute><CurriculumV2 /></ProfileRequiredRoute> },
  { path: "/candidatos", component: <CandidatosProvider><Candidatos /></CandidatosProvider> },
  { path: "/candidatos/:id", component: <CandidatosProvider><CandidatoDetalhe /></CandidatosProvider> },
  { path: "/admin/users", component: <UsersList /> },
  { path: "/admin/dashboard", component: <Dashboard /> },
  
  // Landing depends on the role (admin → painel, others → perfil).
  { path: "/", exact: true, component: <Home /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
];

// SPA-owned auth pages — only mounted when REACT_APP_AUTH_MODE=custom.
const customAuthRoutes = [
  { path: "/login", component: <SignIn /> },
  { path: "/cadastro", component: <SignUp /> },
  { path: "/confirmar-conta", component: <ConfirmAccount /> },
  { path: "/esqueci-senha", component: <ForgotPassword /> },
  { path: "/redefinir-senha", component: <ResetPassword /> },
];

export { authProtectedRoutes, publicRoutes, customAuthRoutes };